export { default } from './icon-base';

export * from './helper';

export type {
  TIconBaseRef as IconBaseRef,
  IIconPropsGeneric as IconPropsGeneric
} from './types';
